import {
  Extent,
  combineExtents,
  convertGeometryToMapExtent,
  removeNullUndefined,
} from "@nens/shared-utils";
import { ThreediModel as HccThreediModel } from "@nens/threedi/openapi-client";

import { SchematisationRaster, ThreediModel } from "@/types/descriptor-types";

// Global extent covering the entire world
// Latitude: -85 to +85
// Longitude: -180 to +180
export const EXTENT: Extent = [-180, -85, 180, 85];

function convertHccExtentToMapExtent(extent: HccThreediModel["extentZeroD"]): Extent | null {
  if (!extent) return null;
  const [[minLng, minLat], [maxLng, maxLat]] = extent.coordinates;
  return [minLng, minLat, maxLng, maxLat];
}

// Combines a model's extents as returned by the Rana file-descriptor view (GeoJSON LineStrings, snake_case fields).
export function combineProjectModelExtents(threedimodel?: ThreediModel | null): Extent | null {
  if (!threedimodel) return null;

  const extents = removeNullUndefined([
    threedimodel.extent_zero_d && convertGeometryToMapExtent(threedimodel.extent_zero_d),
    threedimodel.extent_one_d && convertGeometryToMapExtent(threedimodel.extent_one_d),
    threedimodel.extent_two_d && convertGeometryToMapExtent(threedimodel.extent_two_d),
  ]);

  return combineExtents(extents);
}

// Combines a model's extents as returned by the HCC revision/threedimodel endpoint (camelCase Extent objects).
export function combineHccModelExtents(threedimodel?: HccThreediModel | null): Extent | null {
  if (!threedimodel) return null;

  const extents = removeNullUndefined([
    convertHccExtentToMapExtent(threedimodel.extentZeroD),
    convertHccExtentToMapExtent(threedimodel.extentOneD),
    convertHccExtentToMapExtent(threedimodel.extentTwoD),
  ]);

  return combineExtents(extents);
}

export function combineRasterExtents(rasters: SchematisationRaster[]): Extent | null {
  // There is only one DEM raster for a schematisation
  // so we only need to find the DEM raster and convert its extent
  const demRaster = rasters.find(({ type }) => type === "dem_file");

  if (!demRaster) return null;

  return convertGeometryToMapExtent(demRaster.extent);
}
